import React, { ReactNode, useState } from "react";

import classes from "./SwiperNavigation.module.css";
import { ReactComponent as ArrowLeft } from "../../../styles/results/icon/arrowLeft.svg";
import clsx from "clsx";

interface Props {
    swiper: any;
    children?: ReactNode;
    className?: string;
}

const SwiperNavigation = ({ swiper, children, className }: Props) => {
    const [buttonState, setButtonState] = useState({
        isBeginning: true,
        isEnd: false,
    });
    const swiperHandlerClick = (swiper: any, direction: string) => {
        direction === "prev" ? swiper.slidePrev() : direction === "next" && swiper.slideNext();
        setButtonState({
            isBeginning: swiper.isBeginning,
            isEnd: swiper.isEnd,
        });
    };
    return (
        <div className={clsx(classes.swiper, className)}>
            <div
                className={clsx(classes.swiper__prevBtn, buttonState.isBeginning && classes.swiper__disableBtn)}
                onClick={() => swiperHandlerClick(swiper, "prev")}>
                <ArrowLeft />
            </div>
            <div className={classes.swiper__main}>{children}</div>
            <div
                className={clsx(classes.swiper__nextBtn, buttonState.isEnd && classes.swiper__disableBtn)}
                onClick={() => swiperHandlerClick(swiper, "next")}>
                <ArrowLeft />
            </div>
        </div>
    );
};

export default SwiperNavigation;
